export default __webpack_public_path__ + "static/media/save-24.9633e8c7.svg";